import { useContext } from 'react';
import { CookieConsentContext } from '@/contexts/CookieConsentContext';

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (context === undefined) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }
  
  const resetConsent = () => {
    localStorage.removeItem('cookieConsent');
    context.setShowBanner(true);
  };

  const hasUserConsented = () => {
    return context.hasConsented === true;
  };

  const hasUserDenied = () => {
    return context.hasConsented === false;
  };

  const hasUserMadeChoice = () => {
    return context.hasConsented !== null;
  };

  return {
    ...context,
    resetConsent,
    hasUserConsented,
    hasUserDenied,
    hasUserMadeChoice,
  };
}; 